
  import Confirm from '@/components/confirm.vue'
  import DestinationForm from '@/components/destination/form.vue'
  import DestinationEditForm from '@/components/destination/edit.vue'

  export default {
    components: {
      'm-confirm': Confirm,
      'm-destination-form': DestinationForm,
      'm-destination-edit-form': DestinationEditForm
    },
    data () {
      return {
        dialog_destination: false,
        dialog_destination_edit: false,
        destinationItem: {},
        formDestination: {}
      }
    },
    methods: {
      closeDestination () {
        this.dialog_destination = false;
        this.dialog_destination_edit = false;
        console.log('close');
      },
      resetDestination () {
        this.dialog_destination = false;
        this.dialog_destination_edit = false;
        this.formDestination = {};
      },
      saveDestination (data, callback) {
        this.closeDestination();
        // var app = this;
        this.$http
        .post('api/destination', data)
        .then(response => {
          if (callback) {
            callback(response.data.insertId);
          }
          console.log('onSaveDestination response data', response.data);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    }
  }
